import React from 'react';
import { Routes, Route, NavLink, Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '@/components/Layout';
import { PageHeader } from '@/components/PageHeader';
import WhitelistManagement from './admin/WhitelistManagement';
import CustomProductsActivity from './admin/CustomProductsActivity';
import UrlsActivity from './admin/UrlsActivity';
import ResellerRequestsActivity from './admin/ResellerRequestsActivity';
import IssueReportsActivity from './admin/IssueReportsActivity';

const Admin = () => {
  const { t } = useTranslation('admin');
  const location = useLocation();

  const navItems = [
    { path: 'whitelist', label: t('tabs.whitelist') },
    { path: 'custom-products', label: t('tabs.customProducts') },
    { path: 'urls', label: t('tabs.urls') },
    { path: 'reseller-requests', label: t('tabs.resellerRequests') },
    { path: 'issue-reports', label: t('tabs.issueReports') },
  ];

  return (
    <Layout>
      <PageHeader title={<h1 className="text-3xl font-bold">{t('title')}</h1>} />
      <div>
        {/* Tab-styled navigation with routing */}
        <div className="grid w-full grid-cols-2 md:grid-cols-5 h-auto mb-6 bg-muted p-1 rounded-lg">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={`/admin/${item.path}`}
              className={({ isActive }) =>
                `inline-flex items-center justify-center whitespace-normal text-center leading-tight h-auto py-2 px-3 text-sm font-medium rounded-md transition-all ${
                  isActive
                    ? 'bg-background text-foreground shadow-sm'
                    : 'text-muted-foreground hover:text-foreground'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <Routes>
          <Route index element={<Navigate to="whitelist" replace />} />
          <Route path="whitelist" element={<WhitelistManagement />} />
          <Route path="custom-products" element={<CustomProductsActivity />} />
          <Route path="urls" element={<UrlsActivity />} />
          <Route path="reseller-requests" element={<ResellerRequestsActivity />} />
          <Route path="issue-reports" element={<IssueReportsActivity />} />
        </Routes>
      </div>
    </Layout>
  );
};

export default Admin;
